import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Async, await, catch – error handling that won't drive you crazy",
  "description": "",
  "published": "2019-02-08T00:00:00.000Z",
  "redirect_from": ["/blog/async-await-catch-error-handling-that-wont-drive-you-crazy/swizec/8931"],
  "categories": "Computer Science, Front End, Technical",
  "hero": "./img/media-DyvM7QQUUAAiUvA.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Async/await is great. Makes your code easier to read 👌 But the error handling ... oof 🙄`}</p>
    <p>{`Yes try catch is great, it might even make your code easier to read. Combined with JavaScript's modern block scoping it gives rise to the vile side of exception handling.`}</p>
    <p>{`check this out 👇`}</p>
    <p>{`Say you're using `}<a parentName="p" {...{
        "href": "https://github.com/lukeed/httpie"
      }}>{`@lukeed05's httpie`}</a>{` to scream at a server.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/95f19216e04b15520f825e1cd327d0a4/ae953/media-DyvM7QQUUAAiUvA.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.327354260089685%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'197\\'%20viewBox=\\'0%200%20400%20197\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036c-2%202-2%20125%200%20126h352c2-1%202-124%200-126-2-3-350-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95f19216e04b15520f825e1cd327d0a4/ca0a1/media-DyvM7QQUUAAiUvA.webp 223w", "/static/95f19216e04b15520f825e1cd327d0a4/75680/media-DyvM7QQUUAAiUvA.webp 445w", "/static/95f19216e04b15520f825e1cd327d0a4/8d1ba/media-DyvM7QQUUAAiUvA.webp 890w", "/static/95f19216e04b15520f825e1cd327d0a4/cc785/media-DyvM7QQUUAAiUvA.webp 1132w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/95f19216e04b15520f825e1cd327d0a4/e92b6/media-DyvM7QQUUAAiUvA.png 223w", "/static/95f19216e04b15520f825e1cd327d0a4/e66bf/media-DyvM7QQUUAAiUvA.png 445w", "/static/95f19216e04b15520f825e1cd327d0a4/4ef49/media-DyvM7QQUUAAiUvA.png 890w", "/static/95f19216e04b15520f825e1cd327d0a4/ae953/media-DyvM7QQUUAAiUvA.png 1132w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/95f19216e04b15520f825e1cd327d0a4/4ef49/media-DyvM7QQUUAAiUvA.png",
              "alt": "media DyvM7QQUUAAiUvA",
              "title": "media DyvM7QQUUAAiUvA",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`A post request to a naughty server. But the naughty server says no.`}</p>
    <p>{`What do you do? Add a try catch. Wanna handle those JavaScript errors and show a message to the user.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b87a6298b5e40cc36484e6ceaf26148b/d74fe/media-DyvNQaxUwAILdut.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.399103139013455%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'229\\'%20viewBox=\\'0%200%20400%20229\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2034c-3%202-3%20159%200%20161h352c3-2%203-159%200-161H24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b87a6298b5e40cc36484e6ceaf26148b/ca0a1/media-DyvNQaxUwAILdut.webp 223w", "/static/b87a6298b5e40cc36484e6ceaf26148b/75680/media-DyvNQaxUwAILdut.webp 445w", "/static/b87a6298b5e40cc36484e6ceaf26148b/8d1ba/media-DyvNQaxUwAILdut.webp 890w", "/static/b87a6298b5e40cc36484e6ceaf26148b/4b3db/media-DyvNQaxUwAILdut.webp 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b87a6298b5e40cc36484e6ceaf26148b/e92b6/media-DyvNQaxUwAILdut.png 223w", "/static/b87a6298b5e40cc36484e6ceaf26148b/e66bf/media-DyvNQaxUwAILdut.png 445w", "/static/b87a6298b5e40cc36484e6ceaf26148b/4ef49/media-DyvNQaxUwAILdut.png 890w", "/static/b87a6298b5e40cc36484e6ceaf26148b/d74fe/media-DyvNQaxUwAILdut.png 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/b87a6298b5e40cc36484e6ceaf26148b/4ef49/media-DyvNQaxUwAILdut.png",
              "alt": "media DyvNQaxUwAILdut",
              "title": "media DyvNQaxUwAILdut",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You're talking to a naughty server and handling errors like you're supposed to. 👏`}</p>
    <p>{`What about not errors? You can take the data and do something.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/e1d11ed65714eefb06f61c7ab6021342/d74fe/media-DyvNXUrUUAELUz2.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.3677130044843%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'266\\'%20viewBox=\\'0%200%20400%20266\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2034c-2%201-2%207-2%2099l1%2099c2%202%20352%202%20354%200l1-99c0-96%200-98-2-99H24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e1d11ed65714eefb06f61c7ab6021342/ca0a1/media-DyvNXUrUUAELUz2.webp 223w", "/static/e1d11ed65714eefb06f61c7ab6021342/75680/media-DyvNXUrUUAELUz2.webp 445w", "/static/e1d11ed65714eefb06f61c7ab6021342/8d1ba/media-DyvNXUrUUAELUz2.webp 890w", "/static/e1d11ed65714eefb06f61c7ab6021342/4b3db/media-DyvNXUrUUAELUz2.webp 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/e1d11ed65714eefb06f61c7ab6021342/e92b6/media-DyvNXUrUUAELUz2.png 223w", "/static/e1d11ed65714eefb06f61c7ab6021342/e66bf/media-DyvNXUrUUAELUz2.png 445w", "/static/e1d11ed65714eefb06f61c7ab6021342/4ef49/media-DyvNXUrUUAELUz2.png 890w", "/static/e1d11ed65714eefb06f61c7ab6021342/d74fe/media-DyvNXUrUUAELUz2.png 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/e1d11ed65714eefb06f61c7ab6021342/4ef49/media-DyvNXUrUUAELUz2.png",
              "alt": "media DyvNXUrUUAELUz2",
              "title": "media DyvNXUrUUAELUz2",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Oh no what just happened!? 😱`}</p>
    <p>{`You're getting a "Naughty server said no" error even though `}<em parentName="p">{`you`}</em>{` made the mistake. You can't just access properties on undefinedStuff. JavaScript doesn't like that.`}</p>
    <p>{`Blaming the server for your mistakes, tsk`}</p>
    <p><img parentName="p" {...{
        "src": "/c8cf7c6948ea3f31360b60165463ab47/c552b61f64ea71b300d847d9d5e8fb19-tumblr_inline_orekae8QzG1sz9gyq_540.gif",
        "alt": null
      }}></img></p>
    <p>{`Oh I know! We can move using data to after the catch block, right? That should work.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2067c1899e055d8669bf8c29a69e27fa/d74fe/media-DyvN3fQU0AAfjCq.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.22869955156951%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'254\\'%20viewBox=\\'0%200%20400%20254\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2035a3257%203257%200%20001%20185c3%202%20350%201%20352%200s2-8%202-93V35l-178-1-177%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2067c1899e055d8669bf8c29a69e27fa/ca0a1/media-DyvN3fQU0AAfjCq.webp 223w", "/static/2067c1899e055d8669bf8c29a69e27fa/75680/media-DyvN3fQU0AAfjCq.webp 445w", "/static/2067c1899e055d8669bf8c29a69e27fa/8d1ba/media-DyvN3fQU0AAfjCq.webp 890w", "/static/2067c1899e055d8669bf8c29a69e27fa/4b3db/media-DyvN3fQU0AAfjCq.webp 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/2067c1899e055d8669bf8c29a69e27fa/e92b6/media-DyvN3fQU0AAfjCq.png 223w", "/static/2067c1899e055d8669bf8c29a69e27fa/e66bf/media-DyvN3fQU0AAfjCq.png 445w", "/static/2067c1899e055d8669bf8c29a69e27fa/4ef49/media-DyvN3fQU0AAfjCq.png 890w", "/static/2067c1899e055d8669bf8c29a69e27fa/d74fe/media-DyvN3fQU0AAfjCq.png 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/2067c1899e055d8669bf8c29a69e27fa/4ef49/media-DyvN3fQU0AAfjCq.png",
              "alt": "media DyvN3fQU0AAfjCq",
              "title": "media DyvN3fQU0AAfjCq",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Nope. Now data isn't defined because `}<inlineCode parentName="p">{`const { data }`}</inlineCode>{` only works within that try block. 🤦‍♂️`}</p>
    <p>{`You could solve that with a `}<inlineCode parentName="p">{`var`}</inlineCode>{`, but that's old school JavaScript and we all agreed we'd stop using it.`}</p>
    <p>{`What about this?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6d1a094550906d896f6782e3af5d7cdb/5caea/media-DyvOHz8VYAEpl6r.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "81.1659192825112%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'325\\'%20viewBox=\\'0%200%20400%20325\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2040l-1%20124%201%20122h345c2-1%202-8%202-123l-1-123c-2-2-344-2-346%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6d1a094550906d896f6782e3af5d7cdb/ca0a1/media-DyvOHz8VYAEpl6r.webp 223w", "/static/6d1a094550906d896f6782e3af5d7cdb/75680/media-DyvOHz8VYAEpl6r.webp 445w", "/static/6d1a094550906d896f6782e3af5d7cdb/8d1ba/media-DyvOHz8VYAEpl6r.webp 890w", "/static/6d1a094550906d896f6782e3af5d7cdb/ef2bd/media-DyvOHz8VYAEpl6r.webp 996w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/6d1a094550906d896f6782e3af5d7cdb/e92b6/media-DyvOHz8VYAEpl6r.png 223w", "/static/6d1a094550906d896f6782e3af5d7cdb/e66bf/media-DyvOHz8VYAEpl6r.png 445w", "/static/6d1a094550906d896f6782e3af5d7cdb/4ef49/media-DyvOHz8VYAEpl6r.png 890w", "/static/6d1a094550906d896f6782e3af5d7cdb/5caea/media-DyvOHz8VYAEpl6r.png 996w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/6d1a094550906d896f6782e3af5d7cdb/4ef49/media-DyvOHz8VYAEpl6r.png",
              "alt": "media DyvOHz8VYAEpl6r",
              "title": "media DyvOHz8VYAEpl6r",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`This works. But pre-declaring your variables like it's 1978? No thanks. That's why `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/JavaScript_syntax#hoisting"
      }}>{`variable hoisting`}</a>{` was invented in the first place, lol.`}</p>
    <p>{`You `}<em parentName="p">{`could`}</em>{` wrap your code in another level of try/catch ...`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/0f7f5c8175fdd40fe834b7d3c1a09371/d74fe/vlYmz7Q.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75.7847533632287%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'303\\'%20viewBox=\\'0%200%20400%20303\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2034c-2%201-2%208-2%20117l1%20118c2%202%20352%202%20354%200l1-118c0-114%200-116-2-117H24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0f7f5c8175fdd40fe834b7d3c1a09371/ca0a1/vlYmz7Q.webp 223w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/75680/vlYmz7Q.webp 445w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/8d1ba/vlYmz7Q.webp 890w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/4b3db/vlYmz7Q.webp 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/0f7f5c8175fdd40fe834b7d3c1a09371/e92b6/vlYmz7Q.png 223w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/e66bf/vlYmz7Q.png 445w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/4ef49/vlYmz7Q.png 890w", "/static/0f7f5c8175fdd40fe834b7d3c1a09371/d74fe/vlYmz7Q.png 1164w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/0f7f5c8175fdd40fe834b7d3c1a09371/4ef49/vlYmz7Q.png",
              "alt": "vlYmz7Q",
              "title": "vlYmz7Q",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And that's never ever going to get out of hand is it? 😅`}</p>
    <p>{`I'm gonna be honest with you: There's no solution. Not a nice one. Not in JavaScript.`}</p>
    <p>{`Other languages let you catch specific error types. As far as I know, JavaScript doesn't (can't?) support that :/`}</p>
    <p><img parentName="p" {...{
        "src": "/5a90e6d915f170d37e5acbad3e813758/media-9Y5BbDSkSTiY8-giphy.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "we-have-stumbled-upon-the-basic-truth-of-exception-handling"
    }}>{`We have stumbled upon the basic truth of exception handling`}</h2>
    <p>{`It sucks. It always sucks. Whichever way you do it, it's going to make your head spin.`}</p>
    <p>{`You see there's 2 ways software can approach errors:`}</p>
    <ol>
      <li parentName="ol">{`Error passing`}</li>
      <li parentName="ol">{`Exceptions`}</li>
    </ol>
    <h3 {...{
      "id": "error-passing"
    }}>{`Error passing`}</h3>
    <p>{`Error passing is what we used to do with JavaScript in the era of callbacks. Callbacks break try/catch for deep technical reasons so we stopped using them.`}</p>
    <p>{`The logic behind error passing is simple: Every function can return an error, or a result.`}</p>
    <p>{`Great in theory. Except now `}<em parentName="p">{`every function has to check for errors.`}</em>{`. Our code looked like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/04270f098c67b01a21e8b476a0492601/302a4/SO4GEYh.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.16143497757847%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'273\\'%20viewBox=\\'0%200%20400%20273\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2037v101l1%2099h351V37l-176-1-176%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/04270f098c67b01a21e8b476a0492601/ca0a1/SO4GEYh.webp 223w", "/static/04270f098c67b01a21e8b476a0492601/75680/SO4GEYh.webp 445w", "/static/04270f098c67b01a21e8b476a0492601/8d1ba/SO4GEYh.webp 890w", "/static/04270f098c67b01a21e8b476a0492601/260c2/SO4GEYh.webp 1080w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/04270f098c67b01a21e8b476a0492601/e92b6/SO4GEYh.png 223w", "/static/04270f098c67b01a21e8b476a0492601/e66bf/SO4GEYh.png 445w", "/static/04270f098c67b01a21e8b476a0492601/4ef49/SO4GEYh.png 890w", "/static/04270f098c67b01a21e8b476a0492601/302a4/SO4GEYh.png 1080w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/04270f098c67b01a21e8b476a0492601/4ef49/SO4GEYh.png",
              "alt": "SO4GEYh",
              "title": "SO4GEYh",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`1st argument out of a function is an error object, 2nd argument is the result. Check for errors, go into the error path, no errors, do the stuff.`}</p>
    <p>{`Error handling spreads through your codebase like a virus.`}</p>
    <p>{`All languages have this problem. Some on purpose, some by accident. I know Golang made the conscious decision to use error passing because exceptions are a mess and errors should be handled right away.`}</p>
    <p>{`Luke proposes function wrappers to give your async/await code error passing superpowers.`}</p>
    <p>{`[`}<a parentName="p" {...{
        "href": "https://twitter.com/lukeed05/status/1093226585853841409"
      }}>{`https://twitter.com/lukeed05/status/1093226585853841409`}</a>{`]`}</p>
    <p>{`[`}<a parentName="p" {...{
        "href": "https://twitter.com/lukeed05/status/1093227112805191681"
      }}>{`https://twitter.com/lukeed05/status/1093227112805191681`}</a>{`]`}</p>
    <p>{`🤨 I'm not convinced but `}<em parentName="p">{`I guess`}</em></p>
    <h3 {...{
      "id": "exceptions-improve-error-passing"
    }}>{`Exceptions "improve" error passing`}</h3>
    <p>{`Many moons ago someone had the bright idea that hey error passing sucks, let's use exceptions instead. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Exception_handling#History"
      }}>{`Wikipedia says it was Lisp in the 1960s`}</a>{`.`}</p>
    <p>{`Something like this:`}</p>
    <ol>
      <li parentName="ol">{`Error handling sucks`}</li>
      <li parentName="ol">{`Passing errors around and staying vigilant at all times leads to bugs`}</li>
      <li parentName="ol">{`What if we had a sort of error context that handles it behind the scenes?`}</li>
    </ol>
    <p>{`So instead of functions returning errors, they `}<em parentName="p">{`raise`}</em>{` exceptions and hope for the best 🤞`}</p>
    <p>{`When you raise an exception your code stops. The computer then goes back up through the entire call stack to find the nearest `}<inlineCode parentName="p">{`catch`}</inlineCode>{` block.`}</p>
    <p>{`That catch block handles your error and execution continues from there. `}<em parentName="p">{`NOT`}</em>{` from where the error was raised.`}</p>
    <p>{`This is crucial. It means that 90% of the time you're writing happy path code and don't have to worry about errors.`}</p>
    <p>{`And somewhere in your code you make sure to handle all errors.`}</p>
    <p>{`For example that's how Ruby on Rails can make sure that no matter what you do, if all goes to shit, RoR itself will serve a beautiful 500 page telling the user what's up.`}</p>
    <p>{`👌`}</p>
    <p>{`Python does it great too. You never know what sort of error or exception some code might raise and you hope that someone somewhere will know how to handle it.`}</p>
    <p>{`You focus on the good stuff.`}</p>
    <h2 {...{
      "id": "javascripts-missing-exception-piece"
    }}>{`JavaScript's missing exception piece`}</h2>
    <p>{`JavaScript's missing piece are exception types.`}</p>
    <p>{`Take this Python code for example:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/de3cfc6014e81a8e1e84b406d148e434/4c42d/gcHfor6.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.3677130044843%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'265\\'%20viewBox=\\'0%200%20400%20265\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044c-3%203-3%20174%200%20177%203%202%20337%202%20340%200%203-3%203-174%200-177-3-2-337-2-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/de3cfc6014e81a8e1e84b406d148e434/ca0a1/gcHfor6.webp 223w", "/static/de3cfc6014e81a8e1e84b406d148e434/75680/gcHfor6.webp 445w", "/static/de3cfc6014e81a8e1e84b406d148e434/8d1ba/gcHfor6.webp 890w", "/static/de3cfc6014e81a8e1e84b406d148e434/c1a89/gcHfor6.webp 896w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/de3cfc6014e81a8e1e84b406d148e434/e92b6/gcHfor6.png 223w", "/static/de3cfc6014e81a8e1e84b406d148e434/e66bf/gcHfor6.png 445w", "/static/de3cfc6014e81a8e1e84b406d148e434/4ef49/gcHfor6.png 890w", "/static/de3cfc6014e81a8e1e84b406d148e434/4c42d/gcHfor6.png 896w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/de3cfc6014e81a8e1e84b406d148e434/4ef49/gcHfor6.png",
              "alt": "gcHfor6",
              "title": "gcHfor6",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Beautiful ❤️`}</p>
    <p>{`Write happy path code in one block, followed by a series of error handling code for different types of errors.`}</p>
    <p>{`This works across function calls, across entire systems, it just works. It works really really well.`}</p>
    <p>{`If `}<em parentName="p">{`you`}</em>{` don't handle the error, it bubbles up the stack. `}<em parentName="p">{`Someone`}</em>{` will handle it.`}</p>
    <p>{`When all goes to shit, the Python environment itself runs your code in a try/except of sorts so it can print an error message. ✌️`}</p>
    <h2 {...{
      "id": "what-can-you-do"
    }}>{`What can you do?`}</h2>
    <p>{`Give up. You're already writing code. There's your first mistake 😛`}</p>
    <p>{`Error handling is always going to suck. I'm sorry.`}</p>
    <p>{`But you can emulate the python/ruby/java/etc approach in JavaScript and make your life a little easier. You'll have to coordinate with your team because there's no language support, but something like this might work:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "828px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/50e710e969dafe652617e5402ad1f60d/8efc2/2zhKRu7.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "80.26905829596413%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'322\\'%20viewBox=\\'0%200%20400%20322\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%2049c-2%201-2%2013-2%20113v111l2%201c2%201%2035%202%20167%202s165-1%20167-2l2-1V162c0-100%200-112-2-113-2-3-332-3-334%200m33%2014c-3%203%200%2010%205%2010%204%200%207-7%204-10h-9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/50e710e969dafe652617e5402ad1f60d/ca0a1/2zhKRu7.webp 223w", "/static/50e710e969dafe652617e5402ad1f60d/75680/2zhKRu7.webp 445w", "/static/50e710e969dafe652617e5402ad1f60d/712de/2zhKRu7.webp 828w"],
              "sizes": "(max-width: 828px) 100vw, 828px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/50e710e969dafe652617e5402ad1f60d/e92b6/2zhKRu7.png 223w", "/static/50e710e969dafe652617e5402ad1f60d/e66bf/2zhKRu7.png 445w", "/static/50e710e969dafe652617e5402ad1f60d/8efc2/2zhKRu7.png 828w"],
              "sizes": "(max-width: 828px) 100vw, 828px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/50e710e969dafe652617e5402ad1f60d/8efc2/2zhKRu7.png",
              "alt": "2zhKRu7",
              "title": "2zhKRu7",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Of course then you have to set `}<inlineCode parentName="p">{`myType`}</inlineCode>{` on every error you raise and that's tedious too 🤔`}</p>
    <p>{`Sorry that's the best we can do. 🙈`}</p>
    <h1 {...{
      "id": "five-things-friday"
    }}>{`Five things Friday`}</h1>
    <p>{`As promised last week, here's five cool things`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/lukeed/httpie"
      }}>{`The httpie library`}</a>{` my favorite way to talk to servers from JavaScript. Really happy with it. `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1092820724836757504"
      }}>{`Check out my twitter thread review of httpie`}</a></p>
    <p>{`React Hooks are out. 🎣`}</p>
    <p><a parentName="p" {...{
        "href": "https://sebhastian.com/react-hooks-introduction"
      }}>{`Here's a good overview from SebHastian`}</a></p>
    <p>{`You can also read my `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1093562515122864129"
      }}>{`twitter thread about hooks`}</a>{` where I get panned for Doing It Wrong. Fun times.`}</p>
    <p>{`This isn't technical but it `}<em parentName="p">{`is`}</em>{` amazing. `}<a parentName="p" {...{
        "href": "https://medium.com/@shl/reflecting-on-my-failure-to-build-a-billion-dollar-company-b0c31d7db0e7"
      }}>{`@shl reflects on his failure to build a billion dollar company`}</a>{`. Instead he built an amazing business that works. (Gumroad)`}</p>
    <p>{`Michel Westrase whose name I can never spell right (he made MobX) writes `}<a parentName="p" {...{
        "href": "https://michel.codes/blogs/ui-as-an-afterthought"
      }}>{`a great article about UI as an afterthought`}</a></p>
    <p>{`Enjoy your weekend ✌️`}</p>
    <p>{`Cheers, ~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      